// extracted by mini-css-extract-plugin
module.exports = {"mobile":"vMErS","root":"_17vo8","onImage":"_1F1pF"};